import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  Input,
  Form,
  FormGroup,
  FormText,
  FormFeedback,
  Label,
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Badge
} from 'reactstrap'

const P = require('../constants').PERMISSIONS
const R = require('ramda')

class Users extends Component {

  constructor(props) {
    super(props);
    this.onUserSelected = this.onUserSelected.bind(this);
    this.getUserList = this.getUserList.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.filterUserList = this.filterUserList.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onPermissionChange = this.onPermissionChange.bind(this);
    this.save = this.save.bind(this);
    this.cancel = this.cancel.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.toggle = this.toggle.bind(this);
    this.permissions = [
      {value: P.VIEW, text: 'View LOP records', name: 'VIEW'},
      {value: P.ADD, text: 'Add a LOP record', name: 'ADD'},
      {value: P.EDIT_ALL, text: 'Edit all LOP records', name: 'EDIT_ALL'},
      {value: P.EDIT_OWN, text: "Edit user's own LOP records", name: 'EDIT_OWN'},
      {value: P.ROSTERS, text: "Create own rosters", name: 'ROSTERS'},
      {value: P.TARDY, text: "Tardy sweep", name: 'TARDY'},
      {value: P.UPDATE_LIBRARY, text: "Library charges", name: 'UPDATE_LIBRARY'},
      {value: P.UPDATE_FINANCE, text: "Finance charges", name: 'UPDATE_FINANCE'},
      {value: P.UPDATE_GPA, text: "Update GPAs", name: 'UPDATE_GPA'},
      {value: P.REPORTS, text: "Reports", name: 'REPORTS'},
      // {value: P.UPDATE, text: "Update student data", name: 'UPDATE'},
      {value: P.USERS, text: "User maintenance", name: 'USERS'},
    ]
    this.ref = null;
    this.state = {
      selectedUser: null,
      oldId: '',
      userList: [],
      filteredUserList: [],
      filterText: '',
      errors: {
        emailMissing: false,
        emailTaken: false,
        emailInvalid: false
      },
      saveError: false,
      dirty: false,
      confirmDeleteModal: false,
      dbError: false
    }
  }

  componentDidMount() {
    this.getUserList()
  }

  componentWillUnmount() {
    if (this.ref) {
      this.ref.off();
      this.ref = null;
    }
  }

  findUser(userList, id) {
    return R.find(u => u.id === id, userList);
  }

  onUserSelected(evt) {
    let id = evt.currentTarget.getAttribute('data-key')
    let selectedUser = R.clone(this.findUser(this.state.userList, id));
    this.setState({
      id,
      oldId: selectedUser.id,
      selectedUser: selectedUser,
      errors: {
        emailInvalid: false,
        emailMissing: false,
        emailTaken: false
      }
    })
  }

  getUserList() {
    let _this = this;
    this.ref = this.props.db.ref('users');
    this.ref.on('value', snapshot => {
      let userList = [];
      snapshot.forEach(userObj => {
        userList.push({id: userObj.key, ...(userObj.val())})
      })
      let filteredUserList = _this.filterUserList(userList, _this.state.filterText)
      filteredUserList = R.sort((a,b) => (a.email < b.email) ? -1 : 1, filteredUserList);
      _this.setState({
        userList,
        filteredUserList
      });
    }, err => {
      console.log(err);
    })
  }

  onFilterChange(evt) {
    evt.preventDefault();
    this.setState({
      filterText: evt.currentTarget.value,
      filteredUserList: this.filterUserList(this.state.userList, evt.currentTarget.value)
    })
    return false
  }

  filterUserList(userList, filterText) {
    if (filterText === '') return userList;
    let filteredUserList = R.filter(u => {
      return u.email.toLowerCase().indexOf(filterText.toLowerCase()) >= 0
    }, userList);
    return filteredUserList;
  }

  onChange(evt) {
    let field = evt.currentTarget.getAttribute('id')
    let newUser = R.merge(this.state.selectedUser, {[field]: evt.currentTarget.value})
    this.setState({
      errors: this.findErrors(newUser),
      selectedUser: newUser,
      dirty: true
    })
  }

  onPermissionChange(evt) {
    let value = evt.currentTarget.getAttribute('data-value')
    let newUser = R.merge(this.state.selectedUser, {permissions: this.state.selectedUser.permissions ^ value})
    this.setState({
      selectedUser: newUser,
      dirty: true
    })
  }

  toggle() {
    this.setState({confirmDeleteModal: !this.state.confirmDeleteModal})
  }

  doDelete() {
    this.onDelete();
  }

  confirmDelete() {
    this.setState({confirmDeleteModal: true})
  }

  onAdd() {
    let newUser = {
      email: '',
      id: -1,
      permissions: 0x0001,
    }
    this.setState({
      selectedUser: newUser,
      oldId: '',
      dirty: true
    })
  }

  findErrors(user) {
    let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    let errors = this.state.errors;
    let emailList = R.map(aUser => aUser.email, this.state.userList);
    errors.emailTaken = R.includes(user.email, emailList) && (this.state.oldId !== user.id);
    errors.emailMissing = user.email.length === 0;
    errors.emailInvalid = user.email.match(emailRegex) === null;
    return errors;
  }

  onDelete() {
    let _this = this
    if (this.state.selectedUser) {
      this.props.db.ref('users/'+this.state.selectedUser.id).set(null)
        .then(() => {
          _this.setState({
            confirmDeleteModal: false,
            selectedUser: null
          })
          console.log('User deleted')
        });
    }
  }

  save() {
    let _this = this
    const clearError = () => {
      _this.setState({dbError: false})
    }
    let errors = this.findErrors(this.state.selectedUser);
    let u = this.state.selectedUser;
    if (!errors.emailTaken && !errors.emailInvalid && !errors.emailMissing) {
      if (u.id === -1) {
        u.id = this.props.db.ref('users').push().key;
        this.props.db.ref('users/'+u.id).set(R.omit(['id'], u))
          .then(() => {
            _this.setState({
              dirty: false,
              selectedUser: u,
              oldId: u.id,
              errors: {
                emailMissing: false,
                emailTaken: false,
                emailInvalid: false
              },
            })
          });
      } else {
        this.props.db.ref('users/'+u.id).set(R.omit(['id'], u), error => {
          if (error) {
            _this.setState({dbError: true})
            setTimeout(clearError, 2000);
          } else {
            _this.setState({
              dirty: false,
              selectedUser: u,
              oldId: u.id,
              errors: {
                emailMissing: false,
                emailTaken: false,
                emailInvalid: false
              },
            })
          }
        })
      }
    } else {
      this.setState({errors});
    }
  }

  cancel() {
    let newState = {
      dirty: false,
      errors: {
        emailMissing: false,
        emailInvalid: false,
        emailTaken: false
      }
    }
    if (this.state.selectedUser.id === -1) {
      newState.selectedUser = null
    } else {
      newState.selectedUser = R.clone(this.findUser(this.state.userList, this.state.selectedUser.id))
    }
    this.setState(newState)
  }

  render() {
    let _this = this
    let u = this.state.selectedUser;
    let oldId = this.state.oldId;
    let formFeedback = '';
    if (this.state.errors.emailMissing)
      formFeedback = 'Email is required'
    else if (this.state.errors.emailInvalid)
      formFeedback = 'Invalid email'
    else if (this.state.errors.emailTaken)
      formFeedback = 'Email is already being used'

    let list = (this.state.filteredUserList.length === 0) ? <h4 className="text-center">There are no users to display</h4> :
      (
        <div className="">
          <ListGroup>
            {
              this.state.filteredUserList.map((user, idx) => {
                return (
                  <ListGroupItem active={u && user.id === oldId}
                                 key={user.id}
                                 data-key={user.id}
                                 onClick={_this.onUserSelected}
                                 className="">
                    {user.email}
                  </ListGroupItem>
                )
              })
            }
          </ListGroup>
        </div>
      )

    return (
      <div>
        <Row className="master-detail-top-separator">
          <Col md={4}>
            <Card>
              <CardHeader>
                <Form className="list-grid-parent" onSubmit={evt => evt.preventDefault()}>
                  <FormGroup row>
                    <Label for="filter" md={3}>Filter:</Label>
                    <Col sm={9}>
                      <Input type="text" name="filter" id="filter"
                             onChange={this.onFilterChange}
                             value={this.state.filterText}/>
                    </Col>
                  </FormGroup>
                </Form>
                <Row className="student-list-header">
                  <Col md={6} className="">
                    <span>User list <Badge pill>{this.state.filteredUserList.length}</Badge></span>
                  </Col>
                  <Col md={3} className="text-right">
                    <Button color="primary"
                            size="sm"
                            onClick={this.onAdd}
                            title="Add a new user"
                            className="at-risk-add-profile">Add</Button>
                  </Col>
                  <Col md={3} className="text-right">
                    <Button color="primary"
                            size="sm"
                            onClick={this.confirmDelete}
                            disabled={u === null || u.id < 0}
                            title="Delete this user"
                            className="at-risk-add-profile">Del</Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {list}
              </CardBody>
            </Card>
          </Col>
          <Col md={8}>
            <Card>
              <CardHeader>
                {
                  (u) ?
                    <Row>
                      <Col md={8}>
                        {
                          (this.state.dbError) ? <h4 className="error">There was a database error</h4> : <h4>{u.email}</h4>
                        }
                      </Col>
                      <Col md={2}>
                        <Button color="primary" disabled={!this.state.dirty || formFeedback.length > 0} onClick={this.save}>Save</Button>
                      </Col>
                      <Col md={2}>
                        <Button color="primary" disabled={!this.state.dirty} onClick={this.cancel}>Cancel</Button>
                      </Col>
                    </Row> :
                    <h4 className="text-center">No user to display</h4>
                }
              </CardHeader>
              <CardBody>
                {
                  (u) ?
                    <Form>
                      <FormGroup row>
                        <Label for="email" md={6}>Email</Label>
                        <Col md={6}>
                          <Input type="email"
                                 id="email"
                                 name="email"
                                 autoFocus
                                 invalid={(formFeedback.length > 0)}
                                 disabled={this.state.selectedUser.ps_list}
                                 onChange={this.onChange}
                                 placeholder="email"
                                 value={u.email}/>
                          <FormFeedback>{formFeedback}</FormFeedback>
                          <FormText>Email must be in sandi.net domain</FormText>
                        </Col>
                      </FormGroup>
                      <hr/>
                      {
                        this.permissions.map(perm => {
                          return (
                            <FormGroup row key={perm.name}>
                              <Label for={perm.name} md={6}>{perm.text}</Label>
                              <Col md={6}>
                                <FormGroup check>
                                  <Label check>
                                    <Input type="checkbox"
                                           id={perm.name}
                                           data-value={perm.value}
                                           disabled={perm.name === 'VIEW'}
                                           onChange={this.onPermissionChange}
                                           checked={(u.permissions & perm.value) > 0}/>
                                  </Label>
                                </FormGroup>
                              </Col>
                            </FormGroup>
                          )
                        })
                      }
                    </Form> :
                    null
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={this.state.confirmDeleteModal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Confirm delete user</ModalHeader>
          <ModalBody>Are you sure you want to delete {(this.state.selectedUser) ? this.state.selectedUser.email : ''}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.doDelete}>Yes</Button>{' '}
            <Button color="secondary" onClick={this.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }

}

export default Users



// WEBPACK FOOTER //
// ./src/views/Users.js